import { SxProps, Theme } from '@mui/material';

export const toolbarContainerStyles: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '10px 16px',
  backgroundColor: 'background.paper',
  borderBottom: '1px solid',
  borderColor: 'divider',
};

export const navigationContainerStyles: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
};

export const labelStyles: SxProps<Theme> = {
  fontWeight: 500,
  fontSize: '1.1rem',
  ml: 2,
};

export const buttonStyles: SxProps<Theme> = {
  textTransform: 'none',
};

export const viewButtonStyles: SxProps<Theme> = {
  textTransform: 'capitalize',
};

/** Workboard calendar view toggle (month / week) — dark mode only */
export const getViewButtonDarkSx = (selected: boolean): SxProps<Theme> => ({
  textTransform: 'capitalize',
  ...(selected
    ? {
      bgcolor: '#2a2a2f',
      border: '1px solid #ebebee',
      color: 'text.primary',
      '&:hover': {
        bgcolor: '#2a2a2f',
        border: '1px solid #ebebee',
      },
    }
    : {
      bgcolor: '#111111',
      border: '1px solid #646464',
      color: 'text.primary',
      '&:hover': {
        bgcolor: '#111111',
        border: '1px solid #646464',
      },
    }),
});
